import { ArrowSquareOut, X } from '@phosphor-icons/react';
import { SVG_SIZE_M, SVG_SIZE_S } from 'src/constants';
import { Modal } from 'src/components/Modal';
import { Button } from 'src/v2/commonComponents/Button';
import { useContextLimitModal } from 'src/hooks/useContextLimitModal';
import { env } from 'src/env';
import styles from './ContextLimitModal.module.scss';
import { useGetUser } from 'src/hooks';

export const ContextLimitModal = () => {
  const { isOpenTier } = useGetUser();

  const { shouldShowContextLimitModal, changeShouldShowContextLimitModal } =
    useContextLimitModal();

  const handleCloseClick = () => {
    changeShouldShowContextLimitModal(false);
  };

  const handleSuperNinjaClick = () => {
    const base = `${env.REACT_APP_SUPER_NINJA_URL}${!isOpenTier ? 'dashboard' : ''}`;
    window.open(base, '_blank');
    handleCloseClick();
  };

  return (
    <Modal
      open={shouldShowContextLimitModal}
      onClose={handleCloseClick}
      className={styles.root}
      overlayClassName={styles.overlay}
      showCloseIcon={false}
      blockScroll={false}
    >
      <div className={styles.container} data-e2e="context-limit-modal">
        <div className={styles.header}>
          <button
            type="button"
            className={styles.closeButton}
            onClick={handleCloseClick}
            data-e2e="context-limit-modal-close-button"
          >
            <X size={SVG_SIZE_M} color="#ffffff" />
          </button>
        </div>

        <div className={styles.content}>
          <div className={styles.titleWrapper}>
            <p className={styles.title}>Context limit reached</p>

            <p className={styles.caption}>
              Use SuperNinja for advanced file analysis and infinite context
            </p>
          </div>

          <Button color="primary" onClick={handleSuperNinjaClick}>
            <span>SuperNinja</span>
            <ArrowSquareOut size={SVG_SIZE_S} />
          </Button>
        </div>
      </div>
    </Modal>
  );
};
